var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBanner)?_c('div',{staticClass:"company-banner"},[_c('img',{staticClass:"company-banner__img",attrs:{"src":_vm.bannerUrl,"alt":_vm.$t('CompanyBanner.alt')}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }